;(function() {
  'use strict'

  Directive.$inject = ["$window", "shareHeightService"];
  angular.module('app.page').directive('shareHeight', Directive)

  /* @ngInject */
  function Directive($window, shareHeightService) {
    return {
      restrict: 'A',
      scope: {
        name: '@shareHeight',
      },
      link: link,
    }

    function link(scope, elem) {
      scope.$applyAsync(function() {
        shareHeightService.register(scope.name, getHeight, setHeight)
      })

      function getHeight() {
        // log.debug('getHeight', elem[0].clientHeight, elem);
        return elem[0].clientHeight
      }

      function setHeight(height) {
        // log.debug('setHeight', height, elem);
        elem.css('height', height)
      }
    }
  }
})()
